import { availableLodging, needyGuests } from '../../../Game/GamePlayerInfo';
import WeightedChoiceBase from './WeightedChoiceBase';

export default class ShouldIChooseLodging extends WeightedChoiceBase {

    constructor(gameController, aiPackage) {
        super(gameController, aiPackage);
        this.empty_space_count = this._gamePlayerData.lodging.filter(item => item === null).length;
        this.full_space_count = 6 - this.empty_space_count;
        this.i_am_full = this.empty_space_count === 0;
        this.pool_is_empty = availableLodging(this._gameData).length === 0;
        this.needy_guests = [];
        if (!this.i_am_full && !this.pool_is_empty) {
            this.needy_guests = needyGuests(
                this._gamePlayerData);
        }
    }

    _novice = (recursive=false) => {
        if (!recursive) this._aiPackage.addProvenance(
            'What is my Affinity with Lodging', 'Novice');
        let weight = 0;
        if (this.needy_guests.length > 0){
            weight += 3;
        }
        if (!this.pool_is_empty && this.full_space_count < 2) {
            weight += 3;
        }
        if (weight > 5) {
            weight = 4
        }
        this._weight += weight
    }

    _reasonable = (recursive=false) => {
        if (!recursive) this._aiPackage.addProvenance(
            'What is my Affinity with Lodging', 'Reasonable');

        let weight = 0

        let question = 'Do I have a needy Guest?';
        let answer = false;
        let reasoning = 'Accommodate already docked Guests.';
        if (this.needy_guests.length > 0){
            weight += 3;
            answer = true;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);

        question = 'Do I have enough Lodging?';
        answer = false;
        reasoning = this.pool_is_empty
            ? `Pool is empty, cannot buy new Lodging.`
            : `I would like 3, I have ${this.full_space_count}.`;
        if (!this.pool_is_empty && this.full_space_count < 3) {
            weight += 3;
            answer = true;
        }
        this._aiPackage.addProvenance(question, answer, reasoning);
        if (weight > 5) {
            weight = 5
        }
        this._weight += weight
    }

    _persistent = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Lodging', 'Persistent');
        this._reasonable(true);
        if (this._weight < 1) {
            this._weight = 1
        }
    }
    _unreasonable = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Lodging', 'Unreasonable');
        this._reasonable(true);
        if (this._weight < 2) {
            this._weight = 2
        }

    }

    _obsessed = () => {
        this._aiPackage.addProvenance(
            'What is my Affinity with Lodging', 'Obsessed');
        this._reasonable(true);
        if (this._weight < 3) {
            this._weight = 3
        }
    }
}
